import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

LoadingCircle.propTypes = { size: PropTypes.string };
LoadingCircle.defaultProps = { size: 'lg' };

export default function LoadingCircle({ size }) {
  return (
    <div
      className="position-absolute w-100 d-flex align-items-center justify-content-center"
      style={{ top: '50%' }}
    >
      <FontAwesomeIcon
        color="var(--brand-primary)"
        icon={faCircleNotch}
        size={size}
        spin
      />
    </div>
  );
}

export function BrandPrimarySpinningCircle({ size = 'lg' }) {
  return (
    <FontAwesomeIcon
      color="var(--brand-primary)"
      icon={faCircleNotch}
      size={size}
      spin
    />
  );
}
BrandPrimarySpinningCircle.propTypes = { size: PropTypes.string };
